module.exports = __webpack_public_path__ + "static/media/Picture2.d20d8ec4.jpg";